import { showBackArrow } from '../../src/utils/showBackArrow.js'
import { widgetManager } from '../../src/widgetManager/index.js'
import isBetween from 'dayjs/plugin/isBetween'
import dayjsPluginUTC from 'dayjs-plugin-utc'
import intlTelInput from 'intl-tel-input'
import dateLocale from '/app/i18n/locale'
import templates from '/app/templates'
import BaseChannel from './base'
import dayjs from 'dayjs'

const DEFAULT_COUNTRY = 'pl'

export default class GenesysCallbackChannel extends BaseChannel {
  constructor(
    settings,
    {
      i18n,
      genesysCallbackService,
      widgetContainer,
      texts,
      widgetIndex,
      preInteractionForm,
      validatePreInteractionForm,
      initPreInteractionForm,
      adjustPreInteractionFormConsentsStyles,
    }
  ) {
    super(settings, { widgetContainer })
    this.i18n = i18n
    this.callbackService = genesysCallbackService
    this.fields = settings.fields || []
    this.texts = texts
      .filter((x) => x.type === 'callMe')
      .reduce(function (map, obj) {
        map[obj.key] = obj.value
        return map
      }, {})

    this.preInteractionFormTexts = texts
      .filter((x) => x.type === 'preInteractionForm')
      .reduce(function (map, obj) {
        map[obj.key] = obj.value
        return map
      }, {})

    this.filerCountriesText = texts.find((x) => x.key === 'filterCountries')?.value || 'Filter countries'

    this.settings = settings
    this.preInteractionForm = preInteractionForm
    this.preInteractionFormEnabled = false
    this.validatePreInteractionForm = validatePreInteractionForm
    this.initPreInteractionForm = initPreInteractionForm
    this.adjustPreInteractionFormConsentsStyles = adjustPreInteractionFormConsentsStyles
    this.selectedFormType = ''
    this.preInteractionFormIti = {}
    if (preInteractionForm && Object.keys(preInteractionForm).length > 0) {
      this.preInteractionFormEnabled = preInteractionForm.callback.enabled
    }

    this.callMeNowActive = settings.params.callMeNow
    this.callMeScheduledActive = settings.params.callMeScheduled

    this.singleChannelMode = false
    this.channelType = 'callback'
    this.widgetIndex = widgetIndex
    this.activeScreen = 'start'
  }

  setup() {
    this.styleNamespace = 'cce-widget-callback'
  }

  open() {
    this.$element = document.createElement('div')
    this.$element.classList.add(this.styleNamespace)

    this.render()
  }

  render() {
    this.$element.innerHTML = templates.callbackTemplate(this.getTemplateVariables())

    if (this.preInteractionFormEnabled) {
      this.$element.innerHTML += templates.preInteractionFormTemplate({
        form: this.preInteractionForm.callback,
        styleNamespace: this.styleNamespace,
        submitButtonText: this.texts.orderACall,
        texts: this.preInteractionFormTexts,
        additionalClassname: 'cce-widget-callback__screen',
        formDataType: 'schedule',
      })
    }

    this.observeEvents()

    if (this.callMeScheduledActive) this.selectDefaultDate()

    const additionalSettings = this.widgetContainer.settings.widgets[this.widgetIndex].additionalSettings.find((item) => item.key === 'single_channel_mode')
    if (additionalSettings) {
      this.singleChannelMode = additionalSettings.value
    }

    setTimeout(() => {
      if (this.preInteractionFormEnabled) {
        this.preInteractionFormIti.form = this.initPreInteractionForm(
          'callback',
          this.params.defaultCountry || this.widgetContainer.settings.countryCode || DEFAULT_COUNTRY,
          this.filerCountriesText
        )
      }
      this.initInputs()
    }, 0)
  }

  getTemplateVariables() {
    let locale = 'en'
    try {
      locale = this.widgetContainer.settings.widgets[this.widgetIndex].locale
    } catch (e) {}

    const getParamValue = (paramName, defaultValue) => {
      if (this.params.callMeNow && this.params.callMeScheduled) {
        return this.params.callMeScheduledParams[paramName]
      } else if (!this.params.callMeNow && this.params.callMeScheduled) {
        return this.params[paramName]
      }
      return defaultValue
    }

    let slotDuration = getParamValue('slotDuration', 15)
    let reserved = getParamValue('reserved', [])
    let availableSlots = getParamValue('availableSlots', 99)
    let padding = getParamValue('padding', 1)

    dayjs.extend(dayjsPluginUTC)
    dayjs.extend(isBetween)

    return {
      styleNamespace: this.styleNamespace,
      agreementQuestions: [],
      additionalFields: this.fields || [],
      queueId: this.params.queueId,
      texts: this.texts,
      dateLocale: dateLocale[locale],
      callMeScheduled: this.params.callMeScheduled,
      callMeNow: this.params.callMeNow,
      scheduledParams: this.params.callMeScheduledParams,
      callMeScheduledActive: this.callMeScheduledActive,
      slotDuration: slotDuration,
      reserved: reserved,
      availableSlots: availableSlots,
      padding: padding,
      dayjs: dayjs,
    }
  }

  initInputs() {
    setTimeout(() => {}, 0)
    let initialCountry = this.params.defaultCountry || this.widgetContainer.settings.countryCode || DEFAULT_COUNTRY
    let initialCountry2 = this.params.callMeScheduledParams.defaultCountry || this.widgetContainer.settings.countryCode || DEFAULT_COUNTRY

    let options = {
      initialCountry: initialCountry,
      loadUtils: () => import('https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js'),
      separateDialCode: true,
      countrySearch: true,
      fixDropdownWidth: true,
      useFullscreenPopup: false,
    }

    let options2 = {
      initialCountry: initialCountry2,
      loadUtils: () => import('https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js'),
      separateDialCode: true,
      countrySearch: true,
      fixDropdownWidth: true,
      useFullscreenPopup: false,
    }

    this.iti = {}

    if (this.callMeNowActive) {
      let elem = this.$element.querySelector(`.${this.styleNamespace}__now [data-iti]`)
      this.iti.now = intlTelInput(elem, options)
      const itiSearchInput = this.$element.querySelector(`.${this.styleNamespace}__now .iti__search-input`)
      if (itiSearchInput) {
        itiSearchInput.placeholder = this.filerCountriesText
      }
    }

    if (this.callMeScheduledActive) {
      options.initialCountry = this.params.callMeScheduledParams.defaultCountry || this.widgetContainer.settings.countryCode || options.initialCountry
      let elem = this.$element.querySelector(`.${this.styleNamespace}__schedule__phone [data-iti]`)
      this.iti.scheduled = intlTelInput(elem, options2)
      const itiSearchInput = this.$element.querySelector(`.${this.styleNamespace}__schedule__phone .iti__search-input`)
      if (itiSearchInput) {
        itiSearchInput.placeholder = this.filerCountriesText
      }
    }

    this.initInputValidation('schedule')
    this.initInputValidation('immediate')
  }

  initInputValidation(whichInput) {
    const button = document.querySelector(whichInput === 'schedule' ? '.btn-schedule' : '.btn-immediate')
    const input = document.querySelector(whichInput === 'schedule' ? '.cce-widget-callback__input-schedule' : '.cce-widget-callback__input-immediate')
    const errorMessage = document.querySelector(whichInput === 'schedule' ? '.phone-error-message-schedule' : '.phone-error-message-immediate')
    const hideClassName = whichInput === 'schedule' ? 'phone-error-message-schedule-hide' : 'phone-error-message-immediate-hide'
    const iti = whichInput == 'schedule' ? this.iti.scheduled : this.iti.now

    button.addEventListener('click', () => {
      validatePhoneNumber(iti.isValidNumber())
    })
    input.addEventListener('input', hideErrorMessage)
    input.addEventListener('input', formatInput)

    function validatePhoneNumber(isValid) {
      errorMessage.classList.toggle(hideClassName, isValid)
      input.classList.toggle('error', !isValid)
    }

    function formatInput() {
      let value = input.value
      value = value.replace(/[^\d\s]/g, '')
      value = value.replace(/\s{2,}/g, ' ')
      input.value = value
    }

    function hideErrorMessage() {
      errorMessage.classList.add(hideClassName)
      input.classList.remove('error')
    }
  }

  toggleState(state, force = false) {
    this.$element.classList.toggle(`${this.styleNamespace}--${state}`, force)
  }

  handleFormSubmit(type, event, formValues) {
    let iti
    let scriptId = this.params.scriptId

    if (formValues) {
      iti = this.preInteractionFormIti.form
    } else if (type === 'now') {
      iti = this.iti.now
    } else {
      iti = this.iti.scheduled
      scriptId = this.params.callMeScheduledParams.scriptId
    }

    let phoneNumber = iti.getNumber()
    if (!iti.isValidNumber(phoneNumber)) return

    if (this.preInteractionFormEnabled && !formValues) {
      const headerElement = document.querySelector('.cce-widget__window__header')
      const phoneInput = event.target.querySelector('.cce-widget-callback__input')
      const callbackForm = document.querySelector('.cce-widget-callback__pre-interaction-form')
      callbackForm.querySelector('.cce-widget__pre-interaction-form-phoneNumber .iti__tel-input').value = phoneInput.value
      if (type === 'schedule') {
        this.preInteractionFormIti.form.setCountry(this.iti.scheduled.getSelectedCountryData().iso2)
      } else if (type === 'now') {
        this.preInteractionFormIti.form.setCountry(this.iti.now.getSelectedCountryData().iso2)
      }
      if (type === 'now') {
        widgetManager.setWidgetTab('trueengage.callback.pre-interaction-form')
      } else {
        widgetManager.setWidgetTab('trueengage.callback.schedule-pre-interaction-form')
      }

      headerElement.classList.add('cce-widget__window--with-pre-interaction-form')
      if (this.preInteractionFormEnabled) {
        this.adjustPreInteractionFormConsentsStyles('callback')
      }
      return
    }

    let elements = this.$element.querySelector(`form[data-type="${type}"]`).elements

    let queueId = elements['queueId'].value

    let contactDate = null
    const visitorId = this.widgetContainer.token
    const widgetId = this.widgetContainer.settings.widgets[this.widgetIndex].id.toString()

    if (elements['scheduleDate']) {
      contactDate = elements['scheduleDate'].value
    }

    this.toggleState('submitting', true)

    let additionalFields = {
      visitor_id: visitorId,
      te_channel: 'callback',
      widget_id: widgetId,
      script_id: scriptId,
      ga_client_id: this.widgetContainer.googleAnalyticsClientId,
      trueengage_form: formValues,
    }

    let customAttributes = window.trueengage.get('customAttributes') || []
    Object.assign(additionalFields, customAttributes)

    this.callbackService.createCallback({ phoneNumber, contactDate, queueId, additionalFields }, () => {
      this.triggerPublicEvent('action_callback_request', { channel: 'callback' })
      this.widgetContainer.triggerPublicEvent('widget_business_success', { state: widgetManager.getState(), confirmed: true })
      this.toggleState('submitting', false)
      this.toggleState('submitted', true)

      widgetManager.setWidgetTab('trueengage.callback.thanks')
      const form = document.querySelector(`.${this.styleNamespace}__pre-interaction-form form`)
      if (form) {
        const topicItems = form.querySelectorAll(`li`)
        form.reset()
        topicItems.forEach((i) => i.classList.remove('selected'))
      }
    })
  }

  selectDefaultDate() {
    this.$element.querySelector('[data-day]').click()
    this.$element.querySelector('[data-hour]:not(.disabled)').click()
  }

  observeEvents() {
    if (this.callMeScheduledActive) {
      let backArrow = document.querySelector('.cce-widget__window__header--back').classList
      this.$element.querySelector(`button.${this.styleNamespace}__schedule-button`).addEventListener('click', (_) => {
        widgetManager.setWidgetTab('trueengage.callback.schedule')
        this.widgetContainer.triggerPublicEvent('action_channel_click', { channel: 'callMeLater' })
        showBackArrow()
      })
    }

    const thanksButton = this.$element.querySelector(`.${this.styleNamespace}__thanks button`)

    thanksButton.addEventListener('click', () => {
      const isSingleChannel = this.singleChannelMode && this.widgetContainer.settings.widgets[this.widgetIndex].channels.length === 1

      if (isSingleChannel) {
        const tab = this.callMeNowActive ? 'trueengage.callback' : 'trueengage.callback.schedule'
        widgetManager.setWidgetTab(tab)
        widgetManager.closeWidget()
      } else {
        document.querySelector('button[name="ccewBack"]')?.click()
      }
    })

    this.$element.querySelectorAll('[data-day]').forEach((elem) =>
      elem.addEventListener('click', () => {
        let chosenDay = elem.dataset.day
        this.$element.querySelectorAll(`[data-day]`).forEach((elem) => elem.classList.remove('active'))
        elem.classList.add('active')

        this.$element.querySelectorAll(`[data-date]`).forEach((elem) => elem.classList.add('disabled'))

        this.$element.querySelectorAll(`[data-date='${chosenDay}']`).forEach((elem) => elem.classList.remove('disabled'))

        let firstHour = this.$element.querySelector(`[data-date]:not(.disabled)`)
        firstHour.click()
        let box = firstHour.parentElement
        box.scrollLeft = firstHour.offsetLeft - box.offsetLeft
      })
    )

    const scrollContainer = this.$element.querySelector(`.${this.styleNamespace}__schedule__hour__box__container`)
    let pos = { top: 0, left: 0, x: 0, y: 0 }
    const mouseMoveHandler = function (e) {
      // How far the mouse has been moved
      const dx = e.clientX - pos.x
      const dy = e.clientY - pos.y

      // Scroll the element
      scrollContainer.scrollTop = pos.top - dy
      scrollContainer.scrollLeft = pos.left - dx
    }
    const mouseUpHandler = function () {
      scrollContainer.removeEventListener('mousemove', mouseMoveHandler)
      scrollContainer.removeEventListener('mouseup', mouseUpHandler)

      scrollContainer.style.cursor = 'grab'
      scrollContainer.style.removeProperty('user-select')
    }
    const mouseDownHandler = function (e) {
      pos = {
        // The current scroll
        left: scrollContainer.scrollLeft,
        top: scrollContainer.scrollTop,
        // Get the current mouse position
        x: e.clientX,
        y: e.clientY,
      }
      // Change the cursor and prevent user from selecting the text
      scrollContainer.style.cursor = 'grabbing'
      scrollContainer.style.userSelect = 'none'

      scrollContainer.addEventListener('mousemove', mouseMoveHandler)
      scrollContainer.addEventListener('mouseup', mouseUpHandler)
    }

    scrollContainer.addEventListener('mousedown', mouseDownHandler)

    const touchMoveHandler = function (e) {
      // How far the touch has been moved
      const dx = e.touches[0].clientX - pos.x
      const dy = e.touches[0].clientY - pos.y

      // Scroll the element
      scrollContainer.scrollTop = pos.top - dy
      scrollContainer.scrollLeft = pos.left - dx
    }

    const touchEndHandler = function () {
      scrollContainer.removeEventListener('touchmove', touchMoveHandler)
      scrollContainer.removeEventListener('touchend', touchEndHandler)

      scrollContainer.style.cursor = 'grab'
      scrollContainer.style.removeProperty('user-select')
    }

    const touchStartHandler = function (e) {
      e.stopPropagation() // Prevent default behavior, such as scrolling the page

      pos = {
        // The current scroll
        left: scrollContainer.scrollLeft,
        top: scrollContainer.scrollTop,
        // Get the current touch position
        x: e.touches[0].clientX,
        y: e.touches[0].clientY,
      }

      // Change the cursor and prevent user from selecting the text
      scrollContainer.style.cursor = 'grabbing'
      scrollContainer.style.userSelect = 'none'

      scrollContainer.addEventListener('touchmove', touchMoveHandler)
      scrollContainer.addEventListener('touchend', touchEndHandler)
    }

    scrollContainer.addEventListener('touchstart', touchStartHandler)

    this.$element.querySelectorAll('[data-hour]').forEach((elem) =>
      elem.addEventListener('click', () => {
        let chosenDay = elem.dataset.date
        let utcHour = elem.dataset.utchour

        this.$element.querySelectorAll(`[data-hour]`).forEach((elem) => elem.classList.remove('active'))
        elem.classList.add('active')

        //select active day part
        let dayPart = elem.dataset.hourDaypart
        this.$element.querySelectorAll('[data-daypart]').forEach((elem) => elem.classList.remove('active'))
        this.$element.querySelector(`[data-daypart="${dayPart}"]`).classList.add('active')

        let dateInput = this.$element.querySelector('[name=scheduleDate]')
        dateInput.value = `${chosenDay} ${utcHour}`
      })
    )

    //scroll days and hours
    this.$element.querySelectorAll('[data-scroll]').forEach((elem) =>
      elem.addEventListener('click', (e) => {
        let target = e.currentTarget
        let box = this.$element.querySelector(`.${target.dataset.container}`)
        let direction = target.dataset.scroll
        let width = box.offsetWidth
        if (direction === 'prev') box.scrollLeft -= width / 3
        else box.scrollLeft += width / 3
      })
    )

    this.$element.querySelectorAll('[data-daypart]').forEach((elem) =>
      elem.addEventListener('click', () => {
        let chosenDayPart = elem.dataset.daypart
        //TODO what if there are no hours in the selected part?

        this.$element.querySelectorAll('[data-daypart]').forEach((elem) => elem.classList.remove('active'))
        elem.classList.add('active')

        let firstHour = this.$element.querySelector(`[data-date]:not(.disabled)[data-hour-daypart="${chosenDayPart}"]`)
        let box = firstHour.parentElement
        firstHour.click()
        box.scrollLeft = Math.floor((firstHour.offsetLeft - box.offsetLeft) / 10) * 10
      })
    )

    this.$element.querySelectorAll(`.${this.styleNamespace}__form`).forEach((form) =>
      form.addEventListener('submit', (event) => {
        event.preventDefault()
        event.stopPropagation()

        let formType = form.dataset.type
        this.selectedFormType = formType

        this.handleFormSubmit(formType, event)
      })
    )

    if (this.preInteractionFormEnabled) {
      this.$element.querySelector(`.cce-widget-callback__pre-interaction-form`).addEventListener('submit', (event) => {
        event.preventDefault()
        event.stopPropagation()
        let formData = new FormData(event.target)

        let formValues = Object.fromEntries(formData.entries())
        if (!this.validatePreInteractionForm('callback', this.preInteractionFormIti.form, this.preInteractionFormTexts)) return
        Object.keys(formValues).forEach((key) => {
          if (key.startsWith('consents[')) {
            delete formValues[key]
          }
        })

        event.target.querySelectorAll("input[type='checkbox']").forEach((checkbox) => {
          let match = checkbox.name.match(/^consents\[(.+)\]$/)
          if (match) {
            if (!formValues.consents) formValues.consents = {}
            formValues.consents[match[1]] = checkbox.checked
          }
        })

        if (this.preInteractionFormIti.form) {
          formValues.phoneNumber = this.preInteractionFormIti.form.getNumber()
        }

        this.handleFormSubmit(this.selectedFormType, event, formValues)
      })
    }
  }
}
